// extracted by mini-css-extract-plugin
module.exports = {"root":"CompetitionIntro_root__N0T5A"};